import React, { useEffect, useRef, useState } from "react";
import logo from "../yperlogo.png";

import {
    Container,
    Navbar,
    Nav,
    NavDropdown
} from "react-bootstrap";

import {
    Link,
    NavLink,
    useNavigate
} from "react-router-dom";


function Header() {

    const [expanded, setExpanded] = useState(false);

    const [showServices, setShowServices] = useState(false);
    const [showIndustries, setShowIndustries] = useState(false);
    const [aisolution, setAIsolution] = useState(false);

    const servicesTimer = useRef(null);
    const industriesTimer = useRef(null);
    const aisolutionTimer = useRef(null);

    const navigate = useNavigate();


    /* =====================================================
       CLOSE MOBILE MENU
    ===================================================== */

    const handleNavClick = () => {
        setExpanded(false);
        setShowServices(false);
        setShowIndustries(false);
        setAIsolution(false);
    };


    /* =====================================================
       SERVICES
    ===================================================== */

    const openServices = () => {
        clearTimeout(servicesTimer.current);

        servicesTimer.current = setTimeout(() => {
            setShowServices(true);
        }, 80);
    };


    const closeServices = () => {
        clearTimeout(servicesTimer.current);

        servicesTimer.current = setTimeout(() => {
            setShowServices(false);
        }, 180);
    };


    const handleServicesToggle = (isOpen) => {
        setShowServices(isOpen);
    };


    const handleMainServicesClick = (e) => {
        e.preventDefault();

        setShowServices(false);
        setShowIndustries(false);
        setAIsolution(false);
        setExpanded(false);

        navigate("/services");
    };


    /* =====================================================
       INDUSTRIES
    ===================================================== */

    const openIndustries = () => {
        clearTimeout(industriesTimer.current);

        industriesTimer.current = setTimeout(() => {
            setShowIndustries(true);
        }, 80);
    };


    const closeIndustries = () => {
        clearTimeout(industriesTimer.current);

        industriesTimer.current = setTimeout(() => {
            setShowIndustries(false);
        }, 180);
    };


    const handleIndustriesToggle = (isOpen) => {
        setShowIndustries(isOpen);
    };


    const handleMainIndustriesClick = (e) => {
        e.preventDefault();

        setShowServices(false);
        setShowIndustries(false);
        setAIsolution(false);
        setExpanded(false);

        navigate("/industries");
    };

    /* =====================================================
      AISolution
   ===================================================== */

    const openAIsolution = () => {
        clearTimeout(aisolutionTimer.current);

        aisolutionTimer.current = setTimeout(() => {
            setAIsolution(true);
        }, 80);
    };


    const closeAIsolution = () => {
        clearTimeout(aisolutionTimer.current);

        aisolutionTimer.current = setTimeout(() => {
            setAIsolution(false);
        }, 180);
    };


    const handleAIToggle = (isOpen) => {
        setAIsolution(isOpen);
    };


    const handleMainAIClick = (e) => {
        e.preventDefault();

        setShowServices(false);
        setShowIndustries(false);
        setAIsolution(false);
        setExpanded(false);

        navigate("/ai-solutions");
    };


    /* =====================================================
       CLEAN TIMERS
    ===================================================== */

    useEffect(() => {
        return () => {
            clearTimeout(servicesTimer.current);
            clearTimeout(industriesTimer.current);
            clearTimeout(aisolutionTimer.current);
        };
    }, []);


    return (

        <Navbar
            fixed="top"
            expand="lg"
            style={{
                backgroundColor: "#002952",
                height: "75px"
            }}
            expanded={expanded}
            onToggle={setExpanded}
            data-bs-theme="dark"
        >

            <Container fluid>

                {/* =================================================
                    LOGO
                ================================================= */}

                <Link
                    to="/"
                    className="navbar-brand"
                    onClick={handleNavClick}
                >

                    <img
                        src={logo}
                        alt="YperSystem Solution"
                        className="header-logo"
                    />

                    <span>
                        YperSystem Solution
                    </span>

                </Link>


                {/* =================================================
                    MOBILE HAMBURGER
                ================================================= */}

                <Navbar.Toggle
                    aria-controls="basic-navbar-nav"
                />


                {/* =================================================
                    NAVIGATION
                ================================================= */}

                <Navbar.Collapse id="basic-navbar-nav">

                    <Nav className="ms-auto">


                        {/* =================================================
                            HOME
                        ================================================= */}

                        <NavLink
                            to="/"
                            className="My-link"
                            onClick={handleNavClick}
                        >
                            Home
                        </NavLink>

                        {/* =================================================
                            ABOUT
                        ================================================= */}

                        <NavLink
                            to="/aboutus"
                            className="My-link"
                            onClick={handleNavClick}
                        >
                            About Us
                        </NavLink>

                        {/* =================================================
                            HOW WE WORK
                        ================================================= */}

                        <NavLink
                            to="/howwework"
                            className="My-link"
                            onClick={handleNavClick}
                        >
                            How We Work
                        </NavLink>



                        

                        {/* =================================================
                            SERVICES
                        ================================================= */}

                        <div
                            className="nav-dropdown-wrapper"
                            onMouseEnter={openServices}
                            onMouseLeave={closeServices}
                        >

                            <NavDropdown
                                title={
                                    <span
                                        onClick={handleMainServicesClick}
                                        style={{
                                            display: "inline-block",
                                            width: "100%",
                                            paddingTop: "2px",
                                            fontSize: "18px"
                                        }}
                                    >
                                        Services
                                    </span>
                                }

                                id="services-dropdown"

                                className="My-link-dropdown"

                                show={showServices}

                                onToggle={handleServicesToggle}
                            >

                                <NavDropdown.Item
                                    as={Link}
                                    to="/services/custom-software"
                                    onClick={handleNavClick}
                                >
                                    Custom Software
                                </NavDropdown.Item>


                                <NavDropdown.Item
                                    as={Link}
                                    to="/services/erp-business"
                                    onClick={handleNavClick}
                                >
                                    ERP Business
                                </NavDropdown.Item>


                                <NavDropdown.Item
                                    as={Link}
                                    to="/services/web-application"
                                    onClick={handleNavClick}
                                >
                                    Web Application
                                </NavDropdown.Item>


                                <NavDropdown.Item
                                    as={Link}
                                    to="/services/website-development"
                                    onClick={handleNavClick}
                                >
                                    Website Development
                                </NavDropdown.Item>


                                <NavDropdown.Item
                                    as={Link}
                                    to="/services/windows-application"
                                    onClick={handleNavClick}
                                >
                                    Windows Application
                                </NavDropdown.Item>


                                <NavDropdown.Item
                                    as={Link}
                                    to="/services/frontend-development"
                                    onClick={handleNavClick}
                                >
                                    Frontend Development
                                </NavDropdown.Item>


                                <NavDropdown.Item
                                    as={Link}
                                    to="/services/cloud-solutions"
                                    onClick={handleNavClick}
                                >
                                    Cloud Solutions
                                </NavDropdown.Item>


                                <NavDropdown.Item
                                    as={Link}
                                    to="/services/software-maintenance"
                                    onClick={handleNavClick}
                                >
                                    Software Maintenance
                                </NavDropdown.Item>


                                <NavDropdown.Item
                                    as={Link}
                                    to="/services/digital-marketing"
                                    onClick={handleNavClick}
                                >
                                    Digital Marketing
                                </NavDropdown.Item>


                                <NavDropdown.Item
                                    as={Link}
                                    to="/services/domain-hosting"
                                    onClick={handleNavClick}
                                >
                                    Domain Hosting
                                </NavDropdown.Item>


                                <NavDropdown.Item
                                    as={Link}
                                    to="/services/mobile-application"
                                    onClick={handleNavClick}
                                >
                                    Mobile Application
                                </NavDropdown.Item>


                                <NavDropdown.Item
                                    as={Link}
                                    to="/services/database-solutions"
                                    onClick={handleNavClick}
                                >
                                    Database Solutions
                                </NavDropdown.Item>

                            </NavDropdown>

                        </div>


                        {/* =================================================
                            INDUSTRIES
                        ================================================= */}

                        <div
                            className="nav-dropdown-wrapper"
                            onMouseEnter={openIndustries}
                            onMouseLeave={closeIndustries}
                        >

                            <NavDropdown

                                title={
                                    <span
                                        onClick={handleMainIndustriesClick}
                                        style={{
                                            display: "inline-block",
                                            width: "100%",
                                            paddingTop: "2px",
                                            fontSize: "18px"
                                        }}
                                    >
                                        Industries
                                    </span>
                                }

                                id="industries-dropdown"

                                className="My-link-dropdown"

                                show={showIndustries}

                                onToggle={handleIndustriesToggle}
                            >


                                <NavDropdown.Item
                                    as={Link}
                                    to="/industries/education"
                                    onClick={handleNavClick}
                                >
                                    Education
                                </NavDropdown.Item>


                                <NavDropdown.Item
                                    as={Link}
                                    to="/industries/finance"
                                    onClick={handleNavClick}
                                >
                                    Finance & Accounting
                                </NavDropdown.Item>


                                <NavDropdown.Item
                                    as={Link}
                                    to="/industries/healthcare"
                                    onClick={handleNavClick}
                                >
                                    Healthcare
                                </NavDropdown.Item>


                                <NavDropdown.Item
                                    as={Link}
                                    to="/industries/hospitality"
                                    onClick={handleNavClick}
                                >
                                    Hospitality
                                </NavDropdown.Item>


                                <NavDropdown.Item
                                    as={Link}
                                    to="/industries/logistics"
                                    onClick={handleNavClick}
                                >
                                    Logistics & Transportation
                                </NavDropdown.Item>


                                <NavDropdown.Item
                                    as={Link}
                                    to="/industries/manufacturing"
                                    onClick={handleNavClick}
                                >
                                    Manufacturing
                                </NavDropdown.Item>


                                <NavDropdown.Item
                                    as={Link}
                                    to="/industries/professional"
                                    onClick={handleNavClick}
                                >
                                    Professional Services
                                </NavDropdown.Item>


                                <NavDropdown.Item
                                    as={Link}
                                    to="/industries/realestate"
                                    onClick={handleNavClick}
                                >
                                    Real Estate
                                </NavDropdown.Item>


                                <NavDropdown.Item
                                    as={Link}
                                    to="/industries/retailecommerce"
                                    onClick={handleNavClick}
                                >
                                    Retail & E-commerce
                                </NavDropdown.Item>


                                <NavDropdown.Item
                                    as={Link}
                                    to="/industries/startups"
                                    onClick={handleNavClick}
                                >
                                    Startups & Small Businesses
                                </NavDropdown.Item>


                            </NavDropdown>

                        </div>


{/* =================================================
                            AI Solution
                        ================================================= */}

                        <div
                            className="nav-dropdown-wrapper"
                            onMouseEnter={openAIsolution}
                            onMouseLeave={closeAIsolution}
                        >

                            <NavDropdown
                                title={
                                    <span
                                        onClick={handleMainAIClick}
                                        style={{
                                            display: "inline-block",
                                            width: "100%",
                                            paddingTop: "2px",
                                            fontSize: "18px"
                                        }}
                                    >
                                        AI Solution
                                    </span>
                                }

                                id="aisolution-dropdown"

                                className="My-link-dropdown"

                                show={aisolution}

                                onToggle={handleAIToggle}
                            >

                                <NavDropdown.Item
                                    as={Link}
                                    to="/ai/video-creator"
                                    onClick={handleNavClick}
                                >
                                    Video Creator
                                </NavDropdown.Item>


                                <NavDropdown.Item
                                    as={Link}
                                    to="/ai/image-creator"
                                    onClick={handleNavClick}
                                >
                                    Image Creator
                                </NavDropdown.Item>


                                <NavDropdown.Item
                                    as={Link}
                                    to="/ai/business-solutions"
                                    onClick={handleNavClick}
                                >
                                    Business Solutions
                                </NavDropdown.Item>
                            </NavDropdown>
                        </div>

                        {/* =================================================
                            CONTACT
                        ================================================= */}

                        <NavLink
                            to="/contactus"
                            className="My-link"
                            onClick={handleNavClick}
                        >
                            Contact Us
                        </NavLink>

                    </Nav>

                </Navbar.Collapse>

            </Container>

        </Navbar>
    );
}

export default Header;